<template>
  <v-container fluid fill-height>    
    <Login/>
  </v-container>
</template>

<script>
// @ is an alias to /src

//import Calendar from '@/components/Calendar.vue'
import Login from '@/components/Login.vue'

export default {
  name: 'Home',
  components: {
    //HelloWorld,
    //Calendar
    Login
  }
}
</script>

